export enum ETipoRelatorioTitulosFinanceiros {
    Sintetico = 1,
    Analitico = 2,
    BaixadosContas = 3,
    ProjecaoRecebiveis = 4,
}
